export default "__VITE_ASSET__DMCVVeRy__"